export default __webpack_public_path__ + "static/media/brands.5c1389a4.png";